/* Erzeugt von build.ps1 - nicht von Hand aendern. Quelle: spann-werkstatt/ */
/* RUWI Spann-Werkstatt · große Seite als App (r71)

   Steuert nur die vier Reiter. Alles andere — Kacheln, Tische, Regler, Liste — bindet der Motor über die ids, wie bisher.
   Reiter „Höhe" schaltet den Motor in die Arbeitshöhe, jeder andere Reiter zurück ins Spannen. Fährt der gewählte Tisch
   nicht, steht im Reiter ein Satz und ein Knopf zum Premium, statt eines toten Reglers.
   Kein Scrollen von selbst, keine Verlaufseinträge: die Reiter sind keine Schritte, zurück geht es zur vorigen Seite.
   Im Theme das Asset ruwi-spannen-alle.js, geladen nach ruwi-spannen.js. */
(function () {
  'use strict';
  var app = document.querySelector('.ruwi-spa');
  if (!app) return;
  function $(id) { return document.getElementById(id); }
  function jede(liste, fn) { Array.prototype.forEach.call(liste, fn); }
  var reiter = app.querySelectorAll('.spa-reiter [role="tab"]'), felder = app.querySelectorAll('.spa-feld');
  var tafel = app.querySelector('.spa-tafel'), akt = 'arbeit';

  // r79: Abstand vom Seitenanfang statt nur der Kopfzeile (Ankündigungsleiste und Social-Zeile stehen darüber, live 71 px).
  function kopfMessen() { app.style.setProperty('--ruwi-kopf', Math.max(0, Math.round(app.getBoundingClientRect().top + window.pageYOffset)) + 'px'); }
  kopfMessen(); window.addEventListener('load', kopfMessen); window.addEventListener('resize', kopfMessen);

  // Nicht auf bereit() warten. r115 (Ehrenrunde, code-10): bis r109 meldete der Motor auf Tischen ohne Figur (Festool, Sauter)
  // dauerhaft „lädt“, seit r110 dort „bereit“ (WEGE.md) — warten bleibt trotzdem unnötig: die Schnittstelle nimmt Aufrufe jederzeit an;
  // ob der Tisch fährt, sagt der unsichtbare Schalter #ruwi-sp-ansicht, und den setzt der Motor aus den Tischdaten, nicht aus dem geladenen Modell.
  // r117 (Ausbau, Prüfnetz): das stimmt nur mit 3D – ohne WebGL versteckt der Motor den Schalter für jeden Tisch. Diesen Fall trennt hoeheNicht() jetzt ab.
  function api() { return window.SPANN_API && window.SPANN_API.zustand ? window.SPANN_API : null; }

  /* r117 (Ausbau, Prüfnetz): der Satz richtet sich nach den Tischdaten, nicht nach dem geladenen 3D. Der Schalter #ruwi-sp-ansicht ist auch
     dann versteckt, wenn das Gerät kein WebGL kann (Motor: hat3d && hatSchere) – bis r116 stand dann auch beim Premium „Dieser Tisch fährt
     nicht in der Höhe“ mit einem Knopf „Auf dem Hubtisch Premium zeigen“, der nichts tat (probe-alle 1.6). Jetzt: hat der Tisch laut Daten
     einen Hub (zustand().hub) und läuft nur die räumliche Ansicht nicht (status 'ohne3d'), steht ein eigener Absatz mit dem Hub aus den Daten
     da, ohne Knopf. „Fährt nicht“ samt Knopf bleibt für Tische ohne Hub (Schweißtische, MFT, Sauter); dort wählt der Knopf den Premium.
     Weglot (R1): der Hub als gewöhnlicher Text in einem ganzen Satz, vier Fassungen; der zweite Satz steht fest im Section-HTML. */
  function zahl(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function hoeheNicht() {
    var A = api(), nicht = akt === 'hoehe' && !!A && $('ruwi-sp-ansicht').hidden;
    var z = nicht ? A.zustand() : null, ohne3d = !!z && !!z.hub && A.status() === 'ohne3d';
    $('spa-hoeheNicht').hidden = !nicht || ohne3d;
    var o = $('spa-hoeheOhne3d'); if (!o) return; // ältere Section ohne den Absatz: dann steht im Reiter nichts statt eines falschen Satzes
    o.hidden = !ohne3d;
    if (ohne3d) {
      var t = (A.tische ? A.tische() : []).filter(function (x) { return x.k === z.tisch; })[0];
      $('spa-hoeheHub').textContent = (t ? 'Der ' + t.n : 'Dieser Tisch') + ' fährt von ' + zahl(z.hub[0]) + ' bis ' + zahl(z.hub[1]) + ' mm.';
    }
  }

  function zeige(k, fokus) {
    akt = k;
    jede(reiter, function (b) {
      var an = b.getAttribute('data-reiter') === k;
      b.setAttribute('aria-selected', an ? 'true' : 'false'); b.tabIndex = an ? 0 : -1;
      if (an && fokus) b.focus();
    });
    jede(felder, function (f) { f.hidden = f.getAttribute('data-reiter') !== k; });
    app.classList.toggle('spa-hoehe', k === 'hoehe');
    tafel.scrollTop = 0;
    var A = api();
    if (A) {
      var z = A.zustand();
      if (k === 'hoehe' && z.ansicht !== 'hoehe') A.ansicht('hoehe');
      else if (k !== 'hoehe' && z.ansicht === 'hoehe') A.ansicht('spannen');
    }
    hoeheNicht();
  }

  jede(reiter, function (b, i) {
    b.addEventListener('click', function () { zeige(b.getAttribute('data-reiter')); });
    // Pfeiltasten wandern zwischen den Reitern (WAI-ARIA Tabs).
    b.addEventListener('keydown', function (e) {
      var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!n) return;
      e.preventDefault();
      zeige(reiter[(i + n + reiter.length) % reiter.length].getAttribute('data-reiter'), true);
    });
  });

  $('spa-hubtisch').addEventListener('click', function () {
    var A = api(); if (!A) return;
    A.tisch('premium'); A.ansicht('hoehe'); hoeheNicht();
  });

  // r108: keine Summe mehr im Reiter „Liste". Nach der Preis-Entscheidung stehen netto und brutto immer zusammen, und
  // beide passen am Handy nicht in ein Viertel der Breite; eine Zahl allein wäre wieder nur eine der beiden.

  // Der Motor wechselt den Tisch auch ohne den Reiter (geteilter Link, Tischwahl): danach stimmt der Hinweis im Reiter Höhe neu.
  if (window.MutationObserver) new MutationObserver(hoeheNicht).observe($('ruwi-sp-ansicht'), { attributes: true, attributeFilter: ['hidden'] });

  // Bis der Motor steht: dann den Reiter passend zur Ansicht setzen — ein geteilter Link kann in der Arbeitshöhe beginnen.
  // r110 (G074): spätestens nach 60 s aufhören zu fragen — bis r109 lief das Intervall bei einem Tisch ohne CAD-Datei endlos.
  var warteSeit = Date.now();
  var warte = setInterval(function () {
    var A = window.SPANN_API, s = A && A.status ? A.status() : 'laedt';
    if (s === 'laedt' && Date.now() - warteSeit < 60000) return;
    clearInterval(warte);
    if (s === 'bereit' && A.zustand().ansicht === 'hoehe' && akt === 'arbeit') akt = 'hoehe';
    zeige(akt);
  }, 200);
})();
